import { html } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';

/**
 * @component {kat-blueprint-manage-entity-list} KatBlueprintManageEntityList The Manage Entity List Blueprint allows Selling Partners to view and manage a large list of entities, such as listings or orders, that have a consistent underlying structure. <a href="/design-system/blueprints/mel/">Learn more</a>.
 */
@register('kat-blueprint-manage-entity-list')
export class KatBlueprintManageEntityList extends KatLitElement {
  render() {
    return html`<slot></slot>`;
  }
}
